import {Component, OnInit} from '@angular/core';
import {BaseService} from '@core/service/base.service';
import {BaseResponse} from '@core/models/base-response.model';
import {MESSAGE_CODE} from '@shared/constants/message-code.constant';
import {Router} from "@angular/router";
import {ROUTES} from "@modules/pages/page-routing.module";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit{

  constructor(private baseService: BaseService, private router: Router) {
  }

  ngOnInit(): void {
    this.baseService.get("/test-connection").subscribe((res:BaseResponse<any, any>) => {
      if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
        console.log("Connect...")
      }
    }, error => {
      this.router.navigate(["/" + ROUTES.PREFIX + "/" + ROUTES["500"]])
    })
  }
}
